import React, { Component } from 'react';
import Utils from '../utils';
import SettingsContent from './SettingsContent.component';
import SettingsIdentifiers from './SettingsIdentifiers.enum';
import SettingsLeftMenu from './SettingsLeftMenu.component';

const { Session } = Utils;

export default class Settings extends Component {
	constructor(props) {
		super(props);

		const { activeTab } = props;

		// set default active tab to Common/General if it doesn't exist in Preferences
		const { SettingsTabState = SettingsIdentifiers.Common.General } =
			Session.getPreferences();

		this.state = {
			activeTab: activeTab || SettingsTabState,
		};
	}

	// set active tab with the tabId, and save opened tab to preferences
	showTabContent = tabId => {
		this.setState({
			activeTab: tabId,
		});

		Session.savePreferences([
			{
				Name: 'SettingsTabState',
				Value: tabId,
			},
		]);
	};

	render() {
		const { activeTab } = this.state;
		const { completionCallback } = this.props;

		return (
			<div className="common-settings main-view">
				<SettingsLeftMenu
					activeTab={activeTab}
					showTabContent={this.showTabContent}
				/>
				<SettingsContent
					activeTab={activeTab}
					completionCallback={completionCallback}
				/>
			</div>
		);
	}
}
